import { MantineThemeOverride } from '@mantine/core';

export type CenterTheme = NonNullable<MantineThemeOverride['components']>['Center'];

export const Center: CenterTheme = {
  // todo: define
};
